export default "__VITE_ASSET__0f293c70__"